var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcResWarrantyInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.77703 17.9578L9.46754 20.7257C10.1377 21.2283 10.9528 21.5 11.7906 21.5C12.5781 21.5 13.3469 21.2598 13.9944 20.8116L18.15 17.9346C19.0305 17.3251 19.7121 16.4698 20.1098 15.4754C20.3676 14.8311 20.5 14.1434 20.5 13.4494V8.375C20.5 7.48247 20.2105 6.61402 19.675 5.9C19.2331 5.31076 18.6414 4.8506 17.9615 4.56731L14.1078 2.9616C13.3765 2.65688 12.5921 2.5 11.7998 2.5C10.9432 2.5 10.0965 2.6834 9.31667 3.03788L5.98797 4.55092C5.33975 4.84557 4.77608 5.29856 4.34885 5.8682C3.79785 6.60286 3.5 7.49642 3.5 8.41475V13.4037C3.5 14.1279 3.63819 14.8455 3.90715 15.5179C4.29491 16.4873 4.94179 17.3313 5.77703 17.9578Z",
    stroke: "#909090",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 12L10.1464 13.1464C10.3417 13.3417 10.6583 13.3417 10.8536 13.1464L15 9",
    stroke: "#909090",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcResWarrantyInfo);
export default __webpack_public_path__ + "static/media/ic_res_warranty_info.6ca8cc139a6a049a1e364067dfae7a84.svg";
export { ForwardRef as ReactComponent };